import BaseApi from "../../../services/Api";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import React, {useEffect, useState} from "react";
import Tooltip from "../../Popups/Tooltip";
import {Modal, Spinner} from "react-bootstrap";
import Button from "../../Layout/Button";
import style from "./style.module.css"


const ModalUser = ({
  idUser, onUpdate, onCreate, children
}) => {
  const [isLoading, setLoading] = React.useState(true);
  const [isSaving, setSaving] = React.useState(true);
  const [isShow, setShowModal] = React.useState(false);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [image, setImage] = useState(null);
  const [updateImage, setUpdateImage] = useState(null);
  const [password, setPassword] = React.useState('');
  const [passwordConfirmation, setPasswordConfirmation] = React.useState('');

  const buildFormData = () =>{
    const formData = new FormData();
    formData.append("name", name)
    formData.append("email", email)
    
    if(idUser){
      formData.append('_method', 'PUT')
      if (updateImage) {
        formData.append("image", updateImage);
    }
    }else{
      formData.append("password", password)
      formData.append("password_confirmation", passwordConfirmation)
      if (image){
        formData.append("image", image)
  
      }
    }
    return formData
  }

  const formData = buildFormData()

  const onSave = () => {
    Swal.fire({
      title: 'Certeza que deseja salvar?',
      text: "Você não conseguirá reverter isso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: "#198754",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitData();
      } else if (
          result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Operação cancelada!',
          showConfirmButton: false,
          timer: 1500
        })
      }
    })
  }
  const submitData = () => {
    setSaving(true);
    if (idUser) {
      BaseApi.post(`/users/${idUser}`, formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Usuário criado com sucesso!');
        onUpdate && onUpdate(res.data);
      }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados salvos com sucesso!',
          showConfirmButton: false,
          timer: 1500
        })
      }).catch(err => {
        Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || `${err?.response?.data?.message}`, 'error');
        setSaving(false);
      })
    }
    else {
      BaseApi.post('/users', formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Usuário atualizado com sucesso');
        onCreate && onCreate(res.data);
      }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados salvos com sucesso!',
          showConfirmButton: false,
          timer: 1500
        })
      }).catch(err => {
        Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || `${err?.response?.data?.message}`, 'error');
        setSaving(false);
      })
    }
  }

  const handleClose = () => {
    setShowModal(false);
  }

  const handleChangeImage = (e) => {
    const selectedImage = e.target.files[0];
    if (idUser){
        if (selectedImage)  {
            setUpdateImage(selectedImage);
        }
    }
    else {
        if (selectedImage)  {
            setImage(selectedImage);
        }
    }
};

  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/users${idUser ? `/${idUser}` : ''}`).then(res => {
      let data = res.data;
      setName(data.name);
      setEmail(data.email);
      setImage(data.image)
      setPassword(data.password);
      setPasswordConfirmation(data.password_confirmation);
      setLoading(false);
      setSaving(false);
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar esta ação ou o usuário não foi encontrado.', 'error');
      setShowModal(false);
    })
  }

  useEffect(() => {
    if(isShow) {
      requestData();
    } else {
      setName('');
      setEmail('');
      setImage(null);
      setUpdateImage(null);
      setLoading(true);
      setSaving(true);
    }
  }, [isShow])

  return (
    <>
      {children &&
        React.cloneElement(children, { onClick: (e) => setShowModal(true) })}
      {!children && (
        <Tooltip text={idUser ? "Editar usuário" : "Criar usuário"}>
          <button
            className={`btn btn-${idUser ? "warning" : ""} text-white fa-bold`}
            onClick={(e) => setShowModal(true)}
          >
            <i className={`bi bi-${idUser ? "person-gear" : "plus"}`}></i>
          </button>
        </Tooltip>
      )}
      <Modal
        centered
        scrollable
        onHide={handleClose}
        show={isShow}
        animation={true}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>{idUser ? "Editar" : "Criar"} usuário</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center">
            {isLoading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
          {!isLoading && (
            <>
              <div className="row">
                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="name">Nome </label> 
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Insira o nome"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    
                  />
                </div>
                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="email">Email </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Insira o email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="password">Senha </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    placeholder="Senha"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="confirmPassword">Confirme a Senha </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password_confirmation"
                    placeholder="Confirme a senha"
                    value={passwordConfirmation}
                    onChange={(e) => setPasswordConfirmation(e.target.value)}
                  />
                </div>

                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="image">Imagem </label>

                  <input type="file" accept="image/*"
                  className="form-control"
                  
                  onChange={handleChangeImage} />
                  
                  {idUser ? (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      <img
                        src={image instanceof File ? URL.createObjectURL(image) : image}
                        alt="imagem"
                        style={{ minWidth: 250, width: 350, objectFit: 'cover' }}
                      />
                    </div>
                  ) : 
                    null
                  }

                  {image && !idUser && (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      {idUser ? <img src={image} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                        : <img src={URL.createObjectURL(image)} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                      }
                      </div>
                    )
                  }
                </div>


              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center w-100">
            <div className="d-block me-auto"></div>
            <div className="d-block ms-auto">
              <button
                className="btn btn-danger text-white me-2"
                onClick={handleClose}
              >
                Close
              </button>
              <Button
                loading={isSaving}
                onClick={onSave}
                className="btn btn-success text-white"
              >
                {idUser ? "Editar" : "Criar"}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalUser;